<template lang="pug">
.form-group
  label.form-label {{ $t('create_property_page.images') }}
  .image-drop.text-center.mb-4(
    @click="launchUploader"
    @dragover.prevent
    @drop="onDrop"
  )
    | {{ $t('create_property_page.drag_and_drop') }}
  input.d-none(
    type="file"
    ref="file"
    @change="fileChanged"
    accept="image/jpg,image/png"
    multiple
  )

  .overflow-hidden
    template(v-for="(file, index) in storedFiles")
      .image-preview.mr-2.float-left(
        v-if="!file['_destroy']"
        :style="{ backgroundImage: `url(${file.url})` }"
      )
        i.fas.fa-times(@click="deleteFile(index)")

  .invalid-feedback(v-for='obj in errors' role='alert')
    | {{ getError(obj) }}
</template>

<script>
import errorMessageMixin from '@/mixins/error-message'
import { clone } from 'lodash'

export default {
  mixins: [errorMessageMixin],

  model: {
    prop: 'storedFiles',
    event: 'change'
  },

  props: {
    storedFiles: {
      type: Array,
      default() {
        return []
      }
    },
    externalErrors: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      filesLimit: 5,
      internalErrors: []
    }
  },

  computed: {
    existingFiles() {
      return this.storedFiles.filter(file => !file['_destroy'])
    },
    errors() {
      return this.externalErrors.concat(this.internalErrors)
    }
  },

  updated() {
    this.storedFiles.forEach(file => {
      if (!file.id && !file.url) {
        let reader = new FileReader()

        reader.addEventListener('load', () => {
          file.url = reader.result
          this.$forceUpdate()
        }, false);

        reader.readAsDataURL(file.file)
      }
    })
  },

  methods: {
    launchUploader() {
      this.$refs.file.click()
    },
    onDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      this.handleFiles(e.dataTransfer.files)
    },
    fileChanged(e) {
      this.handleFiles(e.target.files)
      e.target.value = ''
    },
    handleFiles(files) {
      this.internalErrors = []
      let newFiles = Array.from(files)

      if (!this.validFiles(newFiles)) {
        this.$forceUpdate()
        return
      }

      let preparedFiles = newFiles.map(file => {
        return { file: file }
      })

      this.$emit('change', this.storedFiles.concat(preparedFiles))
    },
    deleteFile(index) {
      let files = clone(this.storedFiles)

      if (!files[index].id) {
        files.splice(index, 1)
      } else {
        files[index]['_destroy'] = true
      }

      this.$emit('change', files)
    },
    validFiles(files) {
      files.forEach(file => {
        if (!/image\/(jpe?g|png)/i.test(file.type)) {
          this.internalErrors = [{ error: 'wrong_format' }]
        }
      })

      if (this.existingFiles.length + files.length > this.filesLimit) {
        this.internalErrors = [{ error: 'too_long' }]
      }

      return (this.internalErrors.length == 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.image-drop {
  background: #fff;
  border: 1px dashed #19a8ea;
  border-radius: 4px;
  color: #008bd0;
  font-size: 14px;
  font-weight: 500px;
  height: 120px;
  line-height: 118px;
}

.image-preview {
  background-size: cover;
  height: 96px;
  position: relative;
  width: 96px;

  &::after {
    background: rgba(0, 0, 0, 0.4);
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
  }

  .fa-times {
    color: #fff;
    cursor: pointer;
    display: none;
    font-size: 20px;
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 2;
  }

  &:hover {
    &::after {
      z-index: 1;
    }

    .fa-times {
      display: block;
    }
  }
}

.invalid-feedback {
  color: #dc3545;
  display: block;
  font-size: 100%;
  margin-top: 0.25rem;
  width: 100%;
}
</style>
